var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
class ArmResources extends RestServiceBase {
  constructor() {
    super({
      url: "https://management.azure.com",
      tokenScope: "https://management.azure.com/.default"
    });
  }
  getSubscriptions() {
    return __async(this, null, function* () {
      return yield this._get("/subscriptions?api-version=2016-06-01");
    });
  }
  getTenants() {
    return __async(this, null, function* () {
      return yield this._get("/tenants?api-version=2017-08-01");
    });
  }
  getWorkspaces(subscriptionId) {
    return __async(this, null, function* () {
      return yield this._get(
        `/subscriptions/${subscriptionId}/providers/Microsoft.Experimentation/experimentWorkspaces?api-version=2021-11-01-preview `
      );
    });
  }
}
const ArmResources$1 = new ArmResources();
export {
  ArmResources,
  ArmResources$1 as default
};
//# sourceMappingURL=ArmResources.js.map
